"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _baseMarker = _interopRequireDefault(require("../base-marker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PoiClusterMarker = function PoiClusterMarker(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng,
      pointCount = _ref.pointCount,
      onClick = _ref.onClick;
  var clusterColor = (0, _classnames["default"])({
    'bg-primary fill-primary': pointCount < 50,
    'bg-yellow-500 fill-yellow-500': pointCount >= 50 && pointCount < 150,
    'bg-red-500 fill-red-500': pointCount >= 150
  });
  return /*#__PURE__*/_react["default"].createElement(_baseMarker["default"], {
    lat: lat,
    lng: lng,
    zIndex: 10
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])('p-1 rounded outline-none shadow hover:shadow-md focus:ring flex items-center text-white font-bold text-sm', clusterColor),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithColor, {
    className: "h-4 w-4",
    fill: ""
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "mx-1"
  }, pointCount)));
};

PoiClusterMarker.defaultProps = {
  onClick: function onClick() {}
};
var _default = PoiClusterMarker;
exports["default"] = _default;